import { RemoteConsumptionStandardsService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

const consumptionStandardsService = new RemoteConsumptionStandardsService(httpClient)

export { consumptionStandardsService }
